// extracted by mini-css-extract-plugin
export default {"container":"ScrollDown_container__CibrY","animaDown":"ScrollDown_animaDown__ivuDV"};